export default {"src":"/_next/static/media/discgolf.7ef54171.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};